import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
  
import tasks from './modules/Tasks/index'
import cursos from './modules/Cursos/index'
import login from './modules/Login/index'
import tipo_cursos from './modules/Tipo_curso/index'
import disciplinas from './modules/Disciplinas/index'
import gradecurricular from './modules/Gradecurricular/index' 
import tipo_disciplinas from './modules/Tipo_diciplinas/index' 
import oferta_grade_empresa from './modules/Ofertagradeempresa/index' 
import polos from './modules/Polos/index'
import datamateria from './modules/Datamateria/index' 
import funcionarios from './modules/Funcionarios/index' 
import tipos from './modules/Tipos/index' 
import arquivos from './modules/Arquivos/index' 
import alunos from './modules/Alunos/index' 
import mensagens from './modules/Mensagens/index'
import preloader from './modules/Preloader'
import informacao from './modules/Informacao'
import financeiro from './modules/Financeiro'
import professor from './modules/Professor'
import avaliacao from './modules/Avaliacao'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,

  modules: {
    app,
    tasks,
    cursos,
    login,
    tipo_cursos,
    disciplinas,
    gradecurricular,
    tipo_disciplinas,
    oferta_grade_empresa,
    polos,
    datamateria,
    funcionarios,
    tipos,
    arquivos,
    alunos,
    mensagens,
    preloader,
    informacao,
    financeiro,
    professor,
    avaliacao
  },


  state: {},
  mutations: {},
})

Vue.use(VuexI18n.plugin, store)

export default store
